import { type ReactNode } from 'react'
import { Grid, Stack } from '@backyard-ui/core'

import WishlistProviderMethods from 'site/Wishlist/provider'

import { Header } from '../../../ui/Header'
import { Aside } from '../../../ui/Aside'
import { RetailMediaProductsCarousel } from '../../../ui/RetailMediaProductsCarousel'
import { GRID_SIZES } from '../constants'

interface GridContentProps {
  children: ReactNode
  showRetailMedia: boolean
  renderAside?: boolean
  asideContent?: ReactNode
  headerProps?: {
    categoryTitle?: string | null
    contentType?: 'products' | 'services'
  }
}

export const GridContent = ({
  children,
  showRetailMedia,
  renderAside = true,
  asideContent,
  headerProps
}: GridContentProps) => (
  <Grid.Root isGrow>
    <Grid.Item size={GRID_SIZES.aside}>
      {renderAside && (asideContent || <Aside />)}
    </Grid.Item>
    <Grid.Item size={GRID_SIZES.content}>
      <Stack direction="column">
        <Header {...headerProps} />
        <WishlistProviderMethods>{children}</WishlistProviderMethods>
        {showRetailMedia && <RetailMediaProductsCarousel />}
      </Stack>
    </Grid.Item>
  </Grid.Root>
)
